export const ALERT_SIGN_UP_VEHICLES = 'vdp/alertSignUpVehicles/v1';
export const SUBSCRIPTION_EMAIL = 'vdp/subscriptionEmail/v1';
export const SUBSCRIPTION_PHONE = 'vdp/subscriptionPhone/v1';
export const SUBSCRIPTION_PREFERENCE = 'vdp/subscriptionPreference/v1';

export enum ContactType {
  Email = 'Email',
  Phone = 'Phone'
}
